export const RULE_TYPE = "AMAZON_BID_OPTIMIZATION_V2";

/** Log API `type` filter — differs from automation-rule-set `type`. */
export const RULE_LOG_TYPE = "AMAZON_BID_OPTIMIZATION_V2_RULE";

export const STATUS_FILTERS = ["All", "Enabled", "Paused"];

export const DAY_LABELS = ["S", "M", "T", "W", "T", "F", "S"];
export const DAY_NAMES = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];

export const DAY_NAMES_DISPLAY = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

/** Dayparting slot start: 00:00 through 23:00 */
export const SLOT_START_HOURS = Array.from({ length: 24 }, (_, i) => {
  const h = i.toString().padStart(2, "0");
  return { value: `${h}:00`, label: `${h}:00` };
});

/** Dayparting slot end: 01:00 through 24:00 */
export const SLOT_END_HOURS = Array.from({ length: 24 }, (_, i) => {
  const hour = i + 1;
  const label = hour === 24 ? "24:00" : `${hour.toString().padStart(2, "0")}:00`;
  return { value: label, label };
});

export const CASE_TYPES = {
  INCREASE: "increase",
  DECREASE: "decrease",
  PAUSE: "pause",
};

export const CASE_TYPE_CONFIG = {
  [CASE_TYPES.INCREASE]: {
    key: CASE_TYPES.INCREASE,
    label: "Increase Case",
    actionType: "INCREASE_BID",
    maxRules: 2,
    badgeColor: "#16A34A",
    percentageLabel: "Increase bid by %",
    matchTypeLabel: "Match type wise bid increase by %",
  },
  [CASE_TYPES.DECREASE]: {
    key: CASE_TYPES.DECREASE,
    label: "Decrease Case",
    actionType: "DECREASE_BID",
    maxRules: 2,
    badgeColor: "#D97706",
    percentageLabel: "Decrease bid by %",
    matchTypeLabel: "Match type wise bid decrease by %",
  },
  [CASE_TYPES.PAUSE]: {
    key: CASE_TYPES.PAUSE,
    label: "Pause Case",
    actionType: "PAUSE",
    maxRules: 1,
    badgeColor: "#64748B",
    percentageLabel: null,
    matchTypeLabel: null,
  },
};

export const ACTION_TYPE_TO_CASE = {
  INCREASE_BID: CASE_TYPES.INCREASE,
  DECREASE_BID: CASE_TYPES.DECREASE,
  PAUSE: CASE_TYPES.PAUSE,
};

export const MATCH_TYPE_KEYS = ["exact", "phrase", "broad"];

export const MATCH_TYPE_LABELS = {
  exact: "Exact",
  phrase: "Phrase",
  broad: "Broad",
};

/** Slot duration status when min/max bid limits are reached. */
export const SLOT_STATUS_OPTIONS = [
  {
    value: "active",
    menuLabel: "Enabled (Continue at Min/Max Bid)",
  },
  {
    value: "pause",
    menuLabel: "Paused (At Min/Max Bid)",
  },
];

export const GAP_OPTIONS = [
  { value: "USE_DEFAULT_BID", label: "Continue with Current Bid" },
  { value: "PAUSE_TARGETING", label: "Pause Targeting" },
];

export const CAMPAIGN_SELECT_ALL_ID = "__bid_automation_select_all__";
export const CAMPAIGN_FETCH_LIMIT = 150;
export const CAMPAIGN_TABLE_PAGE_SIZE = 25;
export const CAMPAIGN_SELECT_ALL_LABEL = "Select All";

export const GAP_HANDLING_SECTION_TOOLTIP =
  "Set targeting behavior for time periods outside scheduled slots.";

export const PERFORMANCE_FILTERS_TOOLTIP =
  "Set performance conditions (e.g. ROAS, spend, clicks) for this case. The bid change applies only when campaigns meet those conditions for the selected lookback period.";

export const PERF_FILTER_IMPACT_HINT =
  "Campaigns marked with a star match the performance filter for this slot.";

export const ALL_DAYS_CUSTOM_DAYS_TOOLTIP =
  "Use when bids should change by calendar dates. Set your rule start/end dates, pick weekdays, then add slot durations with their own date ranges inside that period.";

export const DAYPARTING_TOOLTIP =
  "Use when bids should change by time of day on selected weekdays. Set your rule start/end dates, pick weekdays, then add slot durations with start/end times (e.g. 09:00–18:00).";

export const TARGETING_EXCLUSION_TOOLTIP =
  "When enabled, Automatic and/or Broad keyword targetings are excluded from bid changes under this rule.";

export const MATCH_TYPE_BID_TOOLTIP =
  "Optional. Override the case default % for Exact, Phrase, and Broad. Unchecked match types use the case default bid %.";

export const AUTOMATION_MODE_OPTIONS = [
  {
    value: "ALL_DAYS_CUSTOM_DAYS",
    label: "All Days / Custom Days",
    tooltip: ALL_DAYS_CUSTOM_DAYS_TOOLTIP,
  },
  {
    value: "DAYPARTING",
    label: "Dayparting",
    tooltip: DAYPARTING_TOOLTIP,
  },
];

export const HEADING_TITLE_COLOR = "#1C1C1E";

export const DEFAULT_GUARD_RAILS = {
  respect_min_bid: true,
  respect_max_bid: true,
  fallback_to_current_bid_on_missing_data: true,
};
